import { useGetCurrentProfile } from 'modules/Profile/model/services';

export type ModerationStatus =
  | 'draft'
  | 'pending_review'
  | 'approved'
  | 'rejected'
  | 'changes_requested';

export const useProfileModeration = () => {
  const { data, isLoading } = useGetCurrentProfile();
  const status = (data?.verification_status || 'draft') as ModerationStatus;
  const isApproved = status === 'approved';

  return {
    isLoading,
    status,
    isApproved,
    comment: data?.verification_comment ?? null,
    isPublic: Boolean(data?.is_public ?? isApproved),
  };
};
